/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  
  var onResize = function(){
    
    //$('.site-wrap').height(Math.max( $(".sticky-sidebar").height() , $(document).height() - $('.site-footer').outerHeight() ));
    //$('.sticky-sidebar').outerHeight(Math.max( $(".sticky-sidebar").height() , window.innerHeight ) + 50);
    
    if($('.sticky-sidebar').outerHeight() < window.innerHeight){
      $('.sticky-sidebar').outerHeight(window.innerHeight);
    }

    $('.site-splash').height(window.innerHeight);

    $('.center-vertical').each(function(){
      $(this).css('margin-top', ($(this).parent().height() - $(this).height()) / 2 + 'px');
    });
  };

  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        var $sidebar   = $(".sticky-sidebar"), 
            $window    = $(window);

        $window.resize(onResize);
        $window.scroll( function() {
            var offset = ( $(document).height() - $('.site-footer').outerHeight() ) - ( $window.scrollTop() + window.innerHeight );
            var offset2 = Math.min($sidebar.height() - window.innerHeight, $window.scrollTop()); 
            $sidebar.css('top', Math.min(offset,0) - offset2 + 'px' );
        });


        onResize();

        $('ul.sub-menu').hide().data('show', false);

        $('ul.nav > li > a').click(function(){
          console.log('click');

          var $subnav = $(this).closest('li').find('ul.sub-menu');
          if($subnav.data('show')){
            $subnav.slideUp('slow');
            $subnav.data('show', false);
          }else{
            $subnav.slideDown('slow');
            $subnav.data('show', true);
          }
        });

        $('.btn-contact-group').click(function(e){
          $('.selected-contact-group').html($(this).html());
          
          
        });

        var contentHeight = Math.max( $(".sticky-sidebar").height() , $(document).height() - $('.site-footer').outerHeight());
        console.log('sidebar height ' + contentHeight);
        
        $('.site-wrap').css('min-height', contentHeight + 'px');
        $('.sticky-sidebar').outerHeight(Math.max( $(".sticky-sidebar").height() , window.innerHeight ) + 50);
    
        $('.marquee').marquee({
          duration: 15000,
          delayBeforeStart: 100,
        });
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'category_news_th': {
      init: function(){
        //TODO switch menu to news
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        console.log('classnm ' + classnm);
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
